import React from 'react';
import styled from 'styled-components';

import { SxProps } from '@mui/material/styles';
import Box from '@mui/material/Box';

import { Segment } from 'ff/debrief/models';
import SegmentItem from './SegmentItem';

interface Props {
    segments?: Segment[];
    currentSegmentId?: string;
    onSegmentClick?: (segment: Segment) => void;
    sx?: SxProps;
}

const SegmentList: React.FC<Props> = props => {
    if (!props.segments) return <Container sx={props.sx}></Container>;
    else
        return (
            <Container sx={props.sx}>
                {props.segments
                    .at(0) // Top level is entire flight
                    .children.map(({ children, ...s }, idx, arr) => {
                        const isParent = children.length > 0;
                        return (
                            <SegmentItem
                                key={s.label + s.startOffsetInSeconds}
                                onClick={props.onSegmentClick}
                                isActive={false}
                                selectedSegmentId={props.currentSegmentId}
                                childSegments={children}
                                level={isParent ? 1 : 0}
                                withBorders={children.length > 0}
                                withTopBorders={
                                    !isParent &&
                                    arr[idx - 1]?.children.length === 0
                                }
                                {...s}
                            />
                        );
                    })}
            </Container>
        );
};

const Container = styled(Box)`
    display: flex;
    flex-direction: column;
    overflow-y: auto;
`;

export default SegmentList;
